// 9fbef606107a605d69c0edbcd8029e5d
import { parseDate } from '@tcp/core/src/utils/parseDate';
import { renderLabel } from '@tcp/core/src/utils/labels/labelUtilty';
import constants from '@tcp/core/src/components/features/account/OrderDetails/OrderDetails.constants';
import { GENERIC_ERROR } from '@tcp/core/src/components/features/account/CustomerHelp/CustomerHelp.constants';
import {
  getCurrentStoreHours,
  isPastStoreHours,
  toTimeString,
  getFormatedOrderDate,
} from '@tcp/core/src/utils/utils';

// eslint-disable-next-line
export const getErrorSelector = (state, labels, errorKey) => {
  if (state && typeof state === 'object') {
    const errorParameters = state.getIn(['errorParameters', '0']);
    const errorCode = state.get('errorKey') || state.get('errorCode');
    if (
      (errorParameters &&
        renderLabel(labels[`${errorKey}_${errorParameters}`], `${errorKey}_${errorParameters}`)) ||
      (errorCode && renderLabel(labels[`${errorKey}_${errorCode}`], `${errorKey}_${errorCode}`))
    ) {
      if (errorParameters) {
        return renderLabel(
          labels[`${errorKey}_${errorParameters}`],
          `${errorKey}_${errorParameters}`
        );
      }
      if (
        `${errorKey}_${errorCode}` ===
        renderLabel(labels[`${errorKey}_${errorCode}`], `${errorKey}_${errorCode}`)
      ) {
        return GENERIC_ERROR;
      }
      return renderLabel(labels[`${errorKey}_${errorCode}`], `${errorKey}_${errorCode}`);
    }
    const defaultError =
      state.getIn(['errorMessage', '_error']) || renderLabel(labels[`${errorKey}`], `${errorKey}`);
    return defaultError !== errorKey ? defaultError : GENERIC_ERROR;
  }
};

/**
 * Function to get the store opening or open until hours data
 * @param {object} hours The hours object of the store
 * @param {object} labels The store locator labels
 * @param {object} currentDate The date to be compared with
 * @returns {string} The time when the store next opens or time it is open till
 */

const getTimeInHourAndMinute = (selectedDateToHour, currentDate) => {
  const date = currentDate.getDate();
  const month = currentDate.getMonth();
  const year = currentDate.getFullYear();
  const storeDateTime = selectedDateToHour;
  let selectedDate = storeDateTime.setDate(date);
  selectedDate = storeDateTime.setMonth(month);
  selectedDate = storeDateTime.setFullYear(year);
  let diff = currentDate - selectedDate;
  if (diff < 0) {
    diff *= -1;
  }
  const hh = Math.floor(diff / 1000 / 60 / 60);
  diff -= hh * 1000 * 60 * 60;
  const mm = Math.floor(diff / 1000 / 60);
  let time = `${hh} hrs`;
  if (mm) {
    time = ` ${hh} hrs ${mm} mins`;
  }
  return time;
};

export const getStoreHoursClosingTiming = (
  hours = {
    regularHours: [],
    holidayHours: [],
    regularAndHolidayHours: [],
  },
  labels = {},
  currentDate = {}
) => {
  const { regularHours, holidayHours, regularAndHolidayHours } = hours;
  const intervals = [...regularHours, ...holidayHours, ...regularAndHolidayHours];
  const selectedInterval = getCurrentStoreHours(intervals, currentDate);
  let storeLabel = '';
  const storeTimeLabel = '';
  try {
    if (selectedInterval && selectedInterval[0] && selectedInterval[0].isClosed) {
      storeLabel = renderLabel(labels?.lbl_storeldetails_closed, 'lbl_storeldetails_closed');
      return {
        storeLabel,
        storeTimeLabel,
      };
    }

    const selectedDateToHour = parseDate(selectedInterval[0].openIntervals[0].toHour);

    if (!isPastStoreHours(selectedDateToHour, currentDate)) {
      const closingInLabel = renderLabel(
        labels?.lbl_storeldetails_closing,
        'lbl_storeldetails_closing'
      );
      return {
        storeLabel: closingInLabel,
        storeTimeLabel: getTimeInHourAndMinute(selectedDateToHour, currentDate),
      };
    }

    const openAtLable = renderLabel(labels?.lbl_storelanding_opensAt, 'lbl_storelanding_opensAt');
    const selectedDateFromHour = parseDate(selectedInterval[0].openIntervals[0].fromHour);
    return {
      storeLabel: openAtLable,
      storeTimeLabel: toTimeString(selectedDateFromHour, true),
    };
  } catch (err) {
    return {
      storeLabel: '',
      storeTimeLabel: '',
    };
  }
};

export const getStoreHours = (
  hours = {
    regularHours: [],
    holidayHours: [],
    regularAndHolidayHours: [],
  },
  labels = {},
  currentDate = {},
  returnType
) => {
  const { regularHours, holidayHours, regularAndHolidayHours } = hours;

  const intervals = [...regularHours, ...holidayHours, ...regularAndHolidayHours];
  const selectedInterval = getCurrentStoreHours(intervals, currentDate);
  const isReturnTypeObject = returnType === 'object';
  try {
    if (selectedInterval && selectedInterval[0] && selectedInterval[0].isClosed) {
      if (isReturnTypeObject) {
        return {
          lblText: renderLabel(labels?.lbl_storeldetails_closed, 'lbl_storeldetails_closed'),
          time: '',
        };
      }
      return renderLabel(labels?.lbl_storeldetails_closed, 'lbl_storeldetails_closed');
    }
    const openUntilLabel = renderLabel(
      labels?.lbl_storelanding_openInterval,
      'lbl_storelanding_openInterval'
    );
    const opensAtLabel = renderLabel(labels?.lbl_storelanding_opensAt, 'lbl_storelanding_opensAt');
    const selectedDateToHour = parseDate(selectedInterval[0].openIntervals[0].toHour);
    if (!isPastStoreHours(selectedDateToHour, currentDate)) {
      if (isReturnTypeObject) {
        return {
          lblText: openUntilLabel,
          time: toTimeString(selectedDateToHour, true),
        };
      }
      return `${openUntilLabel} ${toTimeString(selectedDateToHour, true)}`;
    }
    const selectedDateFromHour = parseDate(selectedInterval[0].openIntervals[0].fromHour);
    // Handle the other scenarion
    if (isReturnTypeObject) {
      return {
        lblText: openUntilLabel,
        time: toTimeString(selectedDateToHour, true),
      };
    }
    return `${opensAtLabel} ${toTimeString(selectedDateFromHour, true)}`;
  } catch (err) {
    if (isReturnTypeObject) {
      return {
        lblText: '',
        time: '',
      };
    }
    // Show empty incase no data found.
    return '';
  }
};

export const getBopisOrderMessageAndLabel = (status, ordersLabels, isBopisOrder) => {
  let label;
  let message;

  switch (status) {
    case constants.STATUS_CONSTANTS.ORDER_IN_PROCESS:
    case constants.STATUS_CONSTANTS.ORDER_RECEIVED:
    case constants.STATUS_CONSTANTS.ORDER_USER_CALL_NEEDED:
      label = isBopisOrder
        ? renderLabel(ordersLabels?.lbl_orders_orderInProcess, 'lbl_orders_orderInProcess')
        : renderLabel(ordersLabels?.lbl_orders_OrderReceived, 'lbl_orders_OrderReceived');
      message = isBopisOrder
        ? renderLabel(
            ordersLabels?.lbl_orders_orderIsReadyForPickup,
            'lbl_orders_orderIsReadyForPickup'
          )
        : renderLabel(ordersLabels?.lbl_orders_processing, 'lbl_orders_processing');
      break;
    default:
      label = null;
      message = null;
      break;
  }
  return {
    label,
    message,
  };
};

const getOrderGroupLabelExtended = (
  status,
  ordersLabels,
  pickUpExpirationDate,
  pickedUpDate,
  isBopisOrder
) => {
  let label;
  let message;
  switch (status) {
    case constants.STATUS_CONSTANTS.ITEMS_READY_FOR_PICKUP:
      label = renderLabel(ordersLabels?.lbl_orders_pleasePickupBy, 'lbl_orders_pleasePickupBy');
      message = getFormatedOrderDate(pickUpExpirationDate);
      break;
    case constants.STATUS_CONSTANTS.ORDER_PICKED_UP:
    case constants.STATUS_CONSTANTS.ITEMS_PICKED_UP:
      label = renderLabel(ordersLabels?.lbl_orders_pickedUpOn, 'lbl_orders_pickedUpOn');
      message = getFormatedOrderDate(pickedUpDate);
      break;
    default:
      ({ label, message } = getBopisOrderMessageAndLabel(status, ordersLabels, isBopisOrder));
      break;
  }
  return {
    label,
    message,
  };
};

/**
 * Function to get Order Detail Group Header label and Message
 * @param {object} orderProps orderProps contain status, shippedDate, pickedDate, ordersLabels

 * @returns {object} label and message for order group
 */
export const getOrderGroupLabelAndMessage = (orderProps, ordersLabels) => {
  let label;
  let message;
  const { status, shippedDate, pickedUpDate, isBopisOrder, pickUpExpirationDate } = orderProps;

  switch (status) {
    case constants.STATUS_CONSTANTS.ORDER_SHIPPED:
    case constants.STATUS_CONSTANTS.ORDER_PARTIALLY_SHIPPED:
      label = renderLabel(ordersLabels?.lbl_orders_shippedOn, 'lbl_orders_shippedOn');
      message =
        shippedDate === constants.STATUS_CONSTANTS.NA
          ? shippedDate
          : getFormatedOrderDate(shippedDate);
      break;
    case constants.STATUS_CONSTANTS.ORDER_CANCELED:
    case constants.STATUS_CONSTANTS.ORDER_CANCELLED:
    case constants.STATUS_CONSTANTS.ORDER_EXPIRED:
      label = '';
      message = renderLabel(
        ordersLabels?.lbl_orders_orderCancelMessage,
        'lbl_orders_orderCancelMessage'
      );
      break;
    case constants.STATUS_CONSTANTS.ITEMS_RECEIVED:
      label = renderLabel(ordersLabels?.lbl_orders_orderInProcess, 'lbl_orders_orderInProcess');
      message = renderLabel(
        ordersLabels?.lbl_orders_orderIsReadyForPickup,
        'lbl_orders_orderIsReadyForPickup'
      );
      break;
    default:
      ({ label, message } = getOrderGroupLabelExtended(
        status,
        ordersLabels,
        pickUpExpirationDate,
        pickedUpDate,
        isBopisOrder
      ));
      break;
  }

  return {
    label,
    message,
  };
};
